/**
 * @file 消耗总览
 * @author gaoxunchen
 */

import _ from 'lodash';
import React from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import { Loading } from '@tencent/spaui';

import { currencyFormatV2 } from '@/pages/agency/utils/format';

import HomeItem from '../home-item';
import Summary, { SummaryTheme } from '../summary';
import store from '../../store';

import './index.scoped.less';

const CardCostSummary: React.FC<any> = observer((props) => {
  const { schema = [] } = props;
  const { todayCostData, yesterdayCostData } = store;

  const data: any = {
    today: toJS(todayCostData),
    yesterday: toJS(yesterdayCostData),
  };

  const getValue = (v: Record<string, any>) => {
    if (_.isEmpty(data[_.get((v.key || '').split('.'), '0', 'today')])) {
      return <Loading />;
    }
    const value = _.get(data, v.key, 0);
    switch (v.key) {
      case 'today.total_balance':
      case 'today.total_cost':
      case 'yesterday.total_cost':
        return currencyFormatV2(value, true);
      case 'today.total_advertiser':
      case 'yesterday.total_advertiser':
        return currencyFormatV2(value);
    }
    return value;
  };

  if (!_.isArray(schema)) {
    return null;
  }

  return (
    <HomeItem>
      <div className="card-cost-summary">
        <Summary
          theme={SummaryTheme.theme1}
          schema={schema}
          getValue={getValue}
        />
      </div>
    </HomeItem>
  );
});

export default CardCostSummary;
